<template>
  <div class="options-type-answer">
    <div
      v-if="isAnswerTimeout"
      class="section"
    >
      <QuizOption
        :option="{ title: $t('not_answer') }"
        :hasCheckbox="false"
        :class="{
          'timeout': true,
        }"
      />
    </div>
    <div
      v-else-if="!isAnswerCorrect"
      class="section"
    >
      <QuizOption
        :option="answer"
        :hasCheckbox="false"
        :class="{
          'incorrect': true,
          'checked': true,
        }"
      />
    </div>
    <div class="section">
      <div
        v-if="isAnswerCorrect && !otherCorrectQuiz.length"
        class="section-title"
      >
        {{ $t('your_answer') }}
      </div>
      <div
        v-else-if="!isAnswerCorrect || (isAnswerCorrect && otherCorrectQuiz.length)"
        class="section-title"
      >
        {{ $t('correctAnswerTitle') }}
      </div>
      <div class="section-content">
        <QuizOption
          :option="correctQuizTypeAnswer"
          :hasCheckbox="false"
          :class="{
            'correct': true,
            'incorrect': false,
            'checked': isTypeAnswerExactlyCorrect,
          }"
        />
      </div>
    </div>
    <div
      v-if="otherCorrectQuiz.length"
      class="section"
    >
      <div class="section-title">
        {{ $t('alsoAccepted') }}
      </div>
      <div class="section-content">
        <QuizOption
          v-for="(option, index) in otherCorrectQuiz"
          :key="option.id"
          class="alternative-correct-icon"
          :index="index"
          :option="option"
          :hasCheckbox="false"
          :class="{
            'correct': true,
            'incorrect': false,
            'checked': option.title === answer.title,
            'massive': isMassiveOptions,
            'border-secondary': option.title !== correctQuizTypeAnswer.title
          }"
        />
      </div>
    </div>
  </div>
</template>

<script>
import QuizOption from './QuizOption.vue'

export default {
  components: {
    QuizOption,
  },
  props: {
    quizAnswer: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    answer() {
      if (this.quizAnswer && this.quizAnswer.typeAnswer) {
        return {
          title: this.quizAnswer && this.quizAnswer.typeAnswer,
        }
      }

      return {}
    },
    slideOptions() {
      return this.quizAnswer
        && this.quizAnswer.Slide
        && this.quizAnswer.Slide.SlideOptions
    },
    isAnswerTimeout() {
      return this.quizAnswer && this.quizAnswer.timeoutAnswer
    },
    isAnswerCorrect() {
      const typeAnswer = this.quizAnswer && this.quizAnswer.typeAnswer
      const acceptedAnswer = this.otherCorrectQuiz.some((item) => item.title === typeAnswer)

      return (this.quizAnswer && this.quizAnswer.correct) || acceptedAnswer
    },
    correctQuizTypeAnswer() {
      if (this.quizAnswer
        && this.quizAnswer.Slide
        && this.quizAnswer.Slide.correctQuizTypeAnswer
      ) {
        return {
          title: this.quizAnswer.Slide.correctQuizTypeAnswer,
        }
      }

      return {}
    },
    otherCorrectQuiz() {
      if (this.quizAnswer
        && this.quizAnswer.Slide
        && this.quizAnswer.Slide.otherCorrectQuiz
      ) {
        return JSON.parse(this.quizAnswer.Slide.otherCorrectQuiz)
      }

      return []
    },
    isMassiveOptions() {
      return this.otherCorrectQuiz.length > 9
    },
    isTypeAnswerExactlyCorrect() {
      return this.answer
        && this.correctQuizTypeAnswer
        && this.answer.title === this.correctQuizTypeAnswer.title
    },
  },
}
</script>

<style lang="scss" scoped>
.options-type-answer {
  display: grid;
  row-gap: 24px;
}

.section-title {
  font-size: 0.875rem;
  font-weight: 700;
  margin-bottom: 12px;
}

.section-content {
  display: grid;
  row-gap: 12px;
}
</style>
